module.exports = __webpack_public_path__ + "static/img/virtualReality1.f04ebe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality1.png
// module id = JGND
// module chunks = 13